<template>
  <v-main>

    <v-container fluid id="title-and-cpoy" class="py-10 py-md-15">

      <div v-if="isDebug">
        【デバッグモード】
        <div v-if="!isMobileDevice()">
          <div>PCで表示</div>
        </div>
        <div v-if="isMobileDevice()">
          <div>モバイルで表示</div>
        </div>
      </div>



      <!-- 大見出しh1 -->
      <v-container id="ar_buttons" class="mx-auto text-center text-block mt-md-5">
        <h2 v-html="$t('LP.intro.headering')" class="text-h5 text-md-h3 text-lg-h2 font-weight-bold text-pre-wrap"
          style="color:#FFE200;">
        </h2>
        <p v-html="$t('LP.intro.h_caption')" class="text-caption text-md-body-1 font-weight-bold ext-pre-wrap mt-2">
        </p>
        <div class="mt-lg-10">
          <a href="https://www.tokyomegaillumi.jp/" target="_blank"
            class="text-caption text-md-body-1 font-weight-bold mt-2">
            {{$t('LP.intro.url')}}
          </a>
        </div>
      </v-container>

      <!-- リード文 -->
      <v-container v-if="isMobileDevice()" class="mx-auto text-body-1 text-md-h5 font-weight-bold text-center"
        style="line-height:1.8;">
        <p v-html="$t('LP.intro.lead_sp')" class="text-pre-wrap" style="color:#FFE200;"></p>
      </v-container>

      <v-container v-if="!isMobileDevice()" class="mx-auto text-body-1 text-md-h5 text-lg-h4 font-weight-bold text-center mt-md-10"
        style="line-height:1.8;">
        <p v-html="$t('LP.intro.lead_pc')" class="text-pre-wrap" style="color:#FFE200;"></p>
      </v-container>

      <!-- ハッシュタグ -->
      <v-container class="mt-md-3">
        
        
        <v-row justify="center" class="flex-wrap">
          <div v-for="({tag},i) in $t('LP.intro.hashtag')" :key="i"
            class="text-boy-2 text-sm-body-1 text-md-h6 text-lg-h5 font-weight-bold text-center" style="line-height: 2;">
            <p class="text-no-wrap mx-3">{{tag}}</p>
          </div>
        </v-row>
        
        
      </v-container>


      <!-- 新型コロナウィルス感染症対策について -->
      <v-container class="text-center my-md-3">
        <v-btn class="text-body-1 text-sm-h5  black rounded-0" large dark :href="covid19link" target="_blank">
          <small>{{$t("LP.covid19.title")}}</small>
        </v-btn>
      </v-container>

      <!-- ARボタン -->
      <v-container class="py-15">
        <v-row class="justify-center">
          <v-col  cols="8" sm="6" lg="4" class="pa-1 pa-lg-4 pa-xl-6">
            <a href="./ar/001/index.html" target="_blank">
              <v-img :src="ar_buttons.ar_bigbook"></v-img>
            </a>
          </v-col>
          <!-- <v-col cols="4" sm="3" lg="2" class="pa-1 pa-lg-4 pa-xl-6">
            <a href="./ar/002/" target="_blank">

              <v-img :src="ar_buttons.ar_taiju"></v-img>
            </a>
          </v-col>
          <v-col cols="4" sm="3" lg="2" class="pa-1 pa-lg-4 pa-xl-6">
            <a href="./ar/003/" target="_blank">
              <v-img :src="ar_buttons.ar_hiroba"></v-img>
            </a>
          </v-col> -->
        </v-row>
      </v-container>

      <!-- 推奨環境について -->
      <Spec />

      <!-- BIG BOOK -->
      <v-container id="story" class="mt-15">
        <h3 class="text-h4 font-weight-bold text-center">NAKED BIG BOOK</h3>
        <v-row class="text-center">
          <v-col cols="12" sm="8" offset-sm="2">
            <h4 class="mt-10 text-h6 font-weight-bold">{{$t('LP.big_book.renewal')}}</h4>
            <p class="mt-6">{{$t('LP.big_book.renewal_caption')}}</p>
          </v-col>
          <v-col cols="12" sm="8" offset-sm="2">
            <h4 class="mt-10 text-h6 font-weight-bold">{{$t('LP.big_book.story')}}</h4>
            <p class="mt-6">{{$t('LP.big_book.story_caption')}}</p>
          </v-col>
        </v-row>
      </v-container>

    </v-container>


    <!-- Contents -->
    <v-container fluid id="contents" class="py-15 py-md-16">
      <v-container class="text-center mb-5 pt-md-6">
        <h2 class="h2 font-weight">
          CONTENTS
        </h2>
      </v-container>
      <!-- コンテンツ読み込み -->
      <ContentsNormal />
    </v-container>

    <!-- Contents AR -->
    <v-container fluid id="contents_ar" class="py-15 py-md-16">
      <v-container class="text-center mb-5 pt-md-6">
        <h2 class="h2 font-weight">
          CONTENTS AR
        </h2>
      </v-container>
      <!-- コンテンツ読み込み -->
      <ContentsAr />
    </v-container>


    <!-- PRICE -->
    <v-container fluid id="price" class="py-15 py-md-16">
      <v-container class="text-center mb-5 pt-md-6">
        <h2 class="h2 font-weight">
          PRICE
        </h2>
      </v-container>
      <p class="text-center text-h5 text-lg-h4 font-weight-bold mt-6" style="color:#FFE200;">{{$t('LP.price.title')}}
      </p>
      <p class="text-center text-caption text-lg-body-2 font-weight-bold mt-6">{{$t('LP.price.caption')}}</p>
      <p class="text-center text-h6 text-lg-h4 font-weight-bold mt-10">TOKYO MEGA ILLUMI Official</p>
      <v-row class="mt-6 mt-md-10 mb-10">
        <v-col cols="12" sm="8" offset-sm="2" md="6" offset-md="3">
          <a href="https://www.tokyomegaillumi.jp/index.html" target="_blank">
            <v-img :src="$t('LP.price.banner')" width="100%"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>


    <!-- CREDIT -->
    <credit />


    <!-- TOPへ戻る -->
    <v-container fluid class="text-center background">
      <a v-smooth-scroll href="#app" class="mx-auto text-h6 font-weight-light white--text text-decoration-none">
        <span class="allow-top">＞</span>TOP<span class="allow-top">＞</span>
      </a>
    </v-container>




    <v-footer padless class="background">
      <!-- SNSリンク -->
      <v-container id="links" class="text-center py-10">
        <v-responsive class="mx-auto" max-width="400">
          <v-row>
            <v-col v-for="({icon, url}, i) in links" :key="i" align="center" justify="center">
              <a :href="url" target="_blank">
                <v-img width="36" :src="icon" style="filter:brightness(10);">
                </v-img>
              </a>
            </v-col>
          </v-row>
        </v-responsive>
      </v-container>
      <v-container class="text-center">
        <span class="white--text">&copy; {{ new Date().getFullYear() }} NAKED, inc.</span>
      </v-container>
    </v-footer>



  </v-main>
</template>



<script>
  import isMobile from "ismobilejs";
  import Spec from './DialogSpec.vue';
  import ContentsNormal from './Contents_normal.vue';
  import ContentsAr from './Contents_AR.vue';
  import Credit from './Credit.vue';

  export default {

    name: 'NakedLP',
    components: {
      Spec,
      ContentsNormal,
      ContentsAr,
      Credit,
    },


    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.xsOnly) binding.column = true

        return binding
      },

    },

    methods: {
      changeLocale() {
        this.$emit('change-locale');
      },
    },



    data: () => ({

      //背景画像
      bg1_sp: './Images/bg/ooi_AR_lp_haikei_A_sp.jpg',
      bg1_pc: './Images/bg/ooi_AR_lp_haikei_A_pc.jpg',

      //新型コロナウイルス感染症対策について
      covid19link: 'https://www.tokyomegaillumi.jp/cms/%e6%96%b0%e5%9e%8b%e3%82%b3%e3%83%ad%e3%83%8a%e3%82%a6%e3%82%a3%e3%83%ab%e3%82%b9%e3%81%ae%e6%84%9f%e6%9f%93%e6%8b%a1%e5%a4%a7%e9%98%b2%e6%ad%a2%e7%ad%96%e3%81%ab%e3%81%a4%e3%81%84%e3%81%a6/',

      //ARボタン
      ar_buttons: {
        ar_bigbook: './Images/buttons/ooikiba_button_1_0811.svg',
        ar_taiju: './Images/buttons/ooikeiba_play_button_taiju.svg',
        ar_hiroba: './Images/buttons/ooikeiba_play_button_shiba.svg',
      },


      // 各種SNSのリンク
      //
      // icon => アイコン
      // url => リンク先URL
      links: [{
          icon: './Images/sns/icon_facebook.svg',
          url: 'https://www.facebook.com/NAKEDINC.official/'
        },
        {
          icon: './Images/sns/icon_twitter.svg',
          url: 'https://twitter.com/naked_staff'
        },
        {
          icon: './Images/sns/icon_line.svg',
          url: 'https://page.line.me/nakedinc'
        },
        {
          icon: './Images/sns/icon_instagram.svg',
          url: 'https://www.instagram.com/naked_inc/'
        },
        {
          icon: './Images/sns/icon_youtube.svg',
          url: 'https://www.youtube.com/c/NAKEDINC'
        },
      ],

      // いったん以下は使わない
      //windowWidth: window.innerWidth+'px',

      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function () {
        if (isMobile().any) {
          return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug: false
    }),
  }
</script>